module.exports = __webpack_public_path__ + "web/img/mov.8d929590.png";